const headers = {
    name: "Customers",
    components: [
        {
            type: "search",
            name: "search",
            placeholder: "Search",
            value: "",
        },
        {
            type: "select",
            name: "sort",
            placeholder: "Sort",
            allowClear: true,
            showSearch: false,
            filterOption: true,
            value: null,
            options: [
                { value: 0, label: "Name (A-Z)" },
                { value: 1, label: "Name (Z-A)" },
            ],
        },
        {
            type: "filter",
            name: "status",
            placeholder: "Status",
            value: null,
            allowClear: true,
            showSearch: false,
            filterOption: true,
            options: [
                { value: 0, label: "Inactive" },
                { value: 1, label: "Active" },
            ],
        },
        {
            type: "add",
            path: "/app/inventory/sites/add",
        },
    ],
    navigate: {
        tabs: [
            {
                name: "Batch",
                path: "/app/inventory",
            },
            {
                name: "Transfer",
                path: "/app/inventory/transfer",
                featureKey: "inventory_transfer_receive",
            },
            {
                name: "Received",
                path: "/app/inventory/received",
                featureKey: "inventory_transfer_receive",
            },
            {
                name: "Request",
                path: "/app/inventory/request",
                featureKey: "inventory_request",
            },
            {
                name: "Requested",
                path: "/app/inventory/requested",
                featureKey: "inventory_request",
            },
            {
                name: "Adjustment",
                path: "/app/inventory/adjustment",
                featureKey: "inventory_adjustment",
            },
            {
                name: "Sites",
                path: "",
            }
        ],
    },
};

export default headers;
